module.exports = __webpack_public_path__ + "static/media/gts-store.a3d5ea36.png";